<template>
    <div class="card" :class="'card-' + size" v-if="counter">
        <header v-if="$slots.headline">
            <slot name="headline" />
        </header>

        <div class="card-content">
            <slot name="content" />
        </div>

        <aside class="card-sidebar">
            <span v-if="counter !== null" class="card-counter">{{ counter }}</span>

            <slot name="sidebar" />
        </aside>
    </div>
</template>

<script>
export default {
    name: 'Card',

    props: {
        counter: {
            type: Number,
            default: null
        },

        size: {
            type: String,
            default: '1/2'
        }
    }
}
</script>



// WEBPACK FOOTER //
// Card.vue?68e0e951